export class Address {
  public street_add?: string;
  public extended_add?: string;
  public locality?: string;
  public region?: string;
  public postal_code?: string;
  public country_code?: string;
}
